import isEqual from "lodash/isEqual";
import isEmpty from "lodash/isEmpty";
import merge from "lodash/merge";
import orderBy from "lodash/orderBy";
import isPlainObject from "lodash/isPlainObject";

export default {
    isEqual,
    isEmpty,
    merge,
    orderBy,
    isPlainObject
};
